import { GetterTree } from "vuex";
import { DevicesState } from "./types";
import { RootState } from "../types";

export const getters: GetterTree<DevicesState, RootState> = {
	cancelTokenSource: state => state.cancelTokenSource,
	doors: state => state.doors,
	gettingConfig: state => state.gettingConfig,
	settingConfig: state => state.settingConfig,
	serverConfig: state => state.serverConfig,
	getCurrentServer: state => state.currentServer,
	deviceConfigurationErrors: state => state.deviceConfigurationErrors,
	deviceChanges: state => state.serverDeviceChanges,
	changeErrors: state => state.deviceChangeErrors
};
